const AdjustmentType = {
  SystemCorrection: "system-correction",
};

export default AdjustmentType;
